// utils/NoSSR.js
import { useEffect, useState } from 'react';

export default function NoSSR({ children, fallback = null }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted ? children : fallback;
}
